import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import { SidebarComponent } from '../sidebar/sidebar.component';
import { GlobalSearchComponent } from '../../shared/components/global-search/global-search.component';
import { ToastComponent } from '../../shared/components/toast/toast.component';

@Component({
  selector: 'app-main-layout',
  standalone: true,
  imports: [CommonModule, RouterOutlet, SidebarComponent, GlobalSearchComponent, ToastComponent],
  template: `
    <div class="flex h-screen bg-background">
      <!-- Sidebar -->
      <app-sidebar></app-sidebar>
      
      <!-- Contenu principal -->
      <main class="flex-1 overflow-auto">
        <router-outlet></router-outlet>
      </main>
      
      <!-- Global Search Component - disponible partout -->
      <app-global-search></app-global-search>
      
      <!-- Toast Notifications - disponibles partout -->
      <app-toast></app-toast>
    </div>
  `
})
export class MainLayoutComponent {

}
